module.exports = __webpack_public_path__ + "static/media/BAT-logo.eba3b1d0.png";